export const FRESHCHAT_LOCAL_STORAGE_KEY = 'mt-fc-berry-storage-key';
